// Collection - PLP

import { buildProducts } from "../components/buildProducts";
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Fix for Collection filters on mobile iOS 15
$('body').on('click', '.js-filter-toggle', function () {
  $('.js-filter-container').show();
});
$('body').on('click', '.js-filter-close', function () {
  $('.js-filter-container').hide();
});

// Build the products in the collection.
(async () => {
    const dropdown_toggles = document.querySelectorAll('.js-dropdown-toggle')

    if (dropdown_toggles.length > 0) {
        for (const dropdown_toggle of dropdown_toggles) {
            dropdown_toggle.addEventListener('click', () => {
                dropdown_toggle.classList.toggle('open')
                dropdown_toggle.nextElementSibling.classList.toggle('hidden')
            })

             //add event listeners to add aria-expanded
             dropdown_toggle.addEventListener('mouseover', function() {
        this.setAttribute('aria-expanded', 'true');
    });

      dropdown_toggle.addEventListener('mouseout', function() {
        console.log(this)
        this.setAttribute('aria-expanded', 'false');
      });
        }
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sort_by = urlParams.get('sort_by')



    if (sort_by) {
        const url = location.protocol + "//" + location.host + location.pathname + '?sort_by=' + sort_by;
        document.querySelector('.js-sort').value = url;
    }



    const filters_to_check = {};
    if (document.querySelector('.js-filter')) {

        let size_filters = [];

        document.querySelectorAll('.js-filter-container .size-item a').forEach((e) => {
            size_filters.push(e.textContent.toLowerCase());
        });


        let color_filters = [];

        document.querySelectorAll('.js-filter-container .color-item a').forEach((e) => {
            color_filters.push(e.textContent.toLowerCase());
        });

        filters_to_check.size = [];
        filters_to_check.color = [];

        if (size_filters.length > 0 || color_filters.length > 0) {

            let href = window.location.href,
                active_filters = href.slice((href.lastIndexOf('/')+1), href.includes('?') ? href.indexOf('?') : href.length).split('+');

            for (let i = 0, limit = active_filters.length; i < limit; i++) {
                if (size_filters.includes(active_filters[i])) {
                    filters_to_check.size.push(active_filters[i]);
                } else if (color_filters.includes(active_filters[i])) {
                    filters_to_check.color.push(active_filters[i]);
                }
            }

        }
    }

    // console.log('filters_to_check',filters_to_check);

    const container = document.querySelector('.js-collection')

    await buildProducts(container, filters_to_check);

})()

// Collection description read more buttons
if (document.querySelector('.collection-description')) {
    const collectionDescriptions = Array.from(document.querySelectorAll('.collection-description'));
    const readMoreBtns = Array.from(document.querySelectorAll('.js-collection-read-more'));

    collectionDescriptions.forEach((el, index)=>{
        if (el.scrollHeight == el.clientHeight && el.clientHeight > 0) {
            collectionDescriptions[index].classList.remove('collection-description--truncate');
            readMoreBtns[index].classList.add('hidden');
        }
    });

    readMoreBtns.forEach((el, index)=>{
        el.addEventListener('click', (e)=>{
            collectionDescriptions[index].classList.remove('collection-description--truncate');
            readMoreBtns[index].classList.add('hidden');
        });
    });
}

// Collection footer seo copy read more buttons
if (document.querySelector('.collection-footer-seo')) {
  const footer_seo_copy = document.querySelector('.collection-footer-seo');
  const read_more = document.querySelector('.js-collection-footer-seo-more');

  if (footer_seo_copy.scrollHeight == footer_seo_copy.clientHeight && footer_seo_copy.clientHeight > 0) {
    footer_seo_copy.classList.remove('collection-footer-seo--truncate');
    read_more.classList.add('hidden');
  }

  read_more.addEventListener('click', (e)=>{
    footer_seo_copy.classList.remove('collection-footer-seo--truncate');
    read_more.classList.add('hidden');
  });
}

// Hide show different filter tag placements based on presence of collection menu
if (document.querySelector('.js-collection-menu')) {
    let menu_tags = document.querySelector('.js-filter-tags-menu');
    menu_tags.classList.remove('hidden');
} else if (document.querySelector('.js-filter-tags-default')) {
    let default_tags = document.querySelector('.js-filter-tags-default');
    default_tags.classList.remove('hidden');
}

// Collection price filters
if (document.querySelector('.js-price-filters')) {
  // const price_filters = document.querySelector('.js-price-filters').children;
  const price_filters = document.querySelectorAll('.js-price-filter');
  const tag_filters = document.querySelectorAll('.js-tag-filter a');
  const sort_select = document.querySelector('.js-sort');
  const filters = window.location.search.match(/filter[^&]+/g);
  const sort_by = window.location.search.match(/sort[^&]+/g);
  var min_price;
  var max_price;

  if (filters) {
    min_price = parseInt(filters[0].substring(filters[0].search(/\d/)));
    max_price = parseInt(filters[1].substring(filters[1].search(/\d/)));

    let query_start = '';
    if (sort_by) {
      query_start = '&';
    } else {
      query_start = '?';
    }

    for (let i = 0, limit = tag_filters.length; i < limit; i++) {
      tag_filters[i].href += query_start + filters[0] + '&' + filters[1];
    }
    for (let i = 0, limit = sort_select.options.length; i < limit; i++) {
      sort_select.options[i].value += '&' + filters[0] + '&' + filters[1];
    }
  }

  for (let i = 0, limit = price_filters.length; i < limit; i++) {
    let min = parseInt(price_filters[i].dataset.min);
    let max = parseInt(price_filters[i].dataset.max);

    if (min >= min_price && max <= max_price) {
      price_filters[i].classList.add('price-filter--active');
      let price_filter = price_filters[i].href.substring(price_filters[i].href.indexOf('?') + 1);

      if (sort_by) {
        price_filters[i].href = price_filters[i].href.replace(price_filter,'');
        price_filters[i].href += sort_by;
      } else {
        price_filters[i].href = price_filters[i].href.replace('?' + price_filter,'');
      }
    } else {
      price_filters[i].classList.remove('price-filter--active');
      if (sort_by) {
        price_filters[i].href += '&' + sort_by;
      }
    }

  }
}

// Add a scroll memory to the filter buttons.
document.addEventListener("DOMContentLoaded", function(){
  // when page loads get scrollY pos and scroll
  function removeScrollY() {
    // localStorage.setItem('daily_lace_scrollY', 0);
    localStorage.removeItem('daily_lace_scrollY');
  }
  window.addEventListener('beforeunload', removeScrollY);
  window.addEventListener('pagehide', removeScrollY);

  let scrollY_pos = localStorage.getItem('daily_lace_scrollY');

  if (scrollY_pos) {
    window.scrollTo(0, scrollY_pos);
    // window.scroll({ top: scrollY_pos, left: 0, behavior: 'smooth' });
  }

  // record scrollY when clicking filter buttons or removes
  function scrollMemory(node_list) {
    for (let node of node_list) {
      node.addEventListener('click', () => {
        localStorage.setItem('daily_lace_scrollY', window.scrollY);
        window.removeEventListener('beforeunload', removeScrollY);
        window.removeEventListener('pagehide', removeScrollY);
      }, {capture:true});
    }
  }

  let filter_buttons = document.querySelectorAll('.js-price-filter');
  scrollMemory(filter_buttons);
});
